import { $api } from "../AxiosInstance";

export class EmailCustomService {
  static sendTestEmail(values) {
    return $api.post("/api/admin/email/test", values);
  }
}
